import React, { Fragment } from "react";
import CustomPropTypes from "../../utils/customPropTypes";
import ImageBlock from "../ImageBlock";
import SafeHTML from "../SafeHTML";
export default class ProductCard extends React.Component {
  static propTypes = {
    product: CustomPropTypes.Product
  };
  constructor(props) {
    super(props);
    this.state = {
      active: false
    };
  }
  toggleClass = () => {
    const currentState = this.state.active;
    this.setState({ active: !currentState });
  };
  render() {
    let objProduct = this.props.product;
    const pathname = window.location.pathname;
    
    const title1Replacement = "ColorFlex EZ - For semi–solid shortening";
    const title2Replacement = "Vista - For liquid shortening";
    const title3Replacement = "Vista - For liquids";
    const title4Replacement = "ColorFlex EZ - For powders";
    const title5Replacement = "UltraScan VIS - For liquids and powders";
    const title6Replacement = "Vista - Para bebidas líquidas";
    const title7Replacement = "ColorFlex EZ - Para bebidas en polvo";
    const title8Replacement = "UltraScan VIS - Para bebidas líquidas y en polvo";

    const title9Replacement = "ColorFlex EZ - For small pellets/granules and measurement of canned food in a cup";
    const title10Replacement = "Aeros - For larger treats, non-homogenous pet food, and canned items";
    const title11Replacement = "ColorFlex EZ - Para pequeños pellets/gránulos y medición de comida enlatada en un recipiente.";
    const title12Replacement = "Aeros - Para golosinas más grandes, comida para mascotas no homogénea y productos enlatados.";
  
    if (objProduct) {
      let cardTitle = objProduct.name;
  
      if (pathname.includes("/measuring-the-color-of-shortening")) {
        if (objProduct.name === "ColorFlex EZ") {
          cardTitle = title1Replacement;
        } else if (objProduct.name === "Vista") {
          cardTitle = title2Replacement;
        }
      }

      if (pathname.includes("/food/measuring-the-color-of-pet-food/")) {
        if (objProduct.name === "ColorFlex EZ") {
          cardTitle = title9Replacement;
        } else if (objProduct.name === "Aeros") {
          cardTitle = title10Replacement;
        }
      }

      if (pathname.includes("/es/industries/food/measuring-the-color-of-pet-food/")) {
        if (objProduct.name === "ColorFlex EZ") {
          cardTitle = title11Replacement;
        } else if (objProduct.name === "Aeros") {
          cardTitle = title12Replacement;
        }
      }

      if (pathname.includes("/measuring-the-color-of-tea-drinks")) {
        if (objProduct.name === "Vista") {
          cardTitle = title3Replacement;
        } else if (objProduct.name === "ColorFlex EZ") {
          cardTitle = title4Replacement;
        } else if (objProduct.name === "UltraScan VIS") {
          cardTitle = title5Replacement;
        }
      }

      if (pathname.includes("/measuring-the-color-of-functional-beverages")) {
        if (objProduct.name === "Vista") {
          cardTitle = title3Replacement;
        } else if (objProduct.name === "ColorFlex EZ") {
          cardTitle = title4Replacement;
        } else if (objProduct.name === "UltraScan VIS") {
          cardTitle = title5Replacement;
        }
      }

      if (pathname.includes("/measuring-the-color-of-sports-drinks")) {
        if (objProduct.name === "Vista") {
          cardTitle = title3Replacement;
        } else if (objProduct.name === "ColorFlex EZ") {
          cardTitle = title4Replacement;
        } else if (objProduct.name === "UltraScan VIS") {
          cardTitle = title5Replacement;
        }
      }

      if (pathname.includes("/es/industries/beverages/liquid-beverages/measuring-the-color-of-tea-drinks")) {
        if (objProduct.name === "Vista") {
          cardTitle = title6Replacement;
        } else if (objProduct.name === "ColorFlex EZ") {
          cardTitle = title7Replacement;
        } else if (objProduct.name === "UltraScan VIS") {
          cardTitle = title8Replacement;
        }
      }

      if (pathname.includes("/es/industries/beverages/liquid-beverages/measuring-the-color-of-functional-beverages")) {
        if (objProduct.name === "Vista") {
          cardTitle = title6Replacement;
        } else if (objProduct.name === "ColorFlex EZ") {
          cardTitle = title7Replacement;
        } else if (objProduct.name === "UltraScan VIS") {
          cardTitle = title8Replacement;
        }
      }

      if (pathname.includes("/es/industries/beverages/liquid-beverages/measuring-the-color-of-sports-drinks")) {
        if (objProduct.name === "Vista") {
          cardTitle = title6Replacement;
        } else if (objProduct.name === "ColorFlex EZ") {
          cardTitle = title7Replacement;
        } else if (objProduct.name === "UltraScan VIS") {
          cardTitle = title8Replacement;
        }
      }
    
      const titleParts = cardTitle.split(' - ');
      return (
        <>
          <a
            href={objProduct.url}
            className={"product-card product-card-new" + (this.state.active ? " active" : "")}
            onClick={() => {
              this.toggleClass();
            }}
          >
            <div className="product-card-inner">
              <h4 className="product-card-title">
                {titleParts.length > 1 ? (
                  <>
                    <span className="h4-text">{titleParts[0]}</span>
                    <br />
                    <span className="h5-text">{titleParts[1]}</span>
                  </>
                ) : (
                  <span className="h4-text">{cardTitle}</span>
                )}
              </h4>
  
              <div className="product-card-data">
                <SafeHTML>{objProduct.description}</SafeHTML>
              </div>
              <div className="product-card-object">
                <ImageBlock image={objProduct.image} addWrapper={false} />
              </div>
              <div className="product-card-action">
                <i className="icon icon-direction-right"></i>
              </div>
            </div>
  
            <div className="product-card-hover">
              <h4 className="product-card-title">{cardTitle}</h4>
              <div className="product-card-data">
                <SafeHTML>{objProduct.description}</SafeHTML>
              </div>
              <div className="product-card-action">
                <i className="icon icon-direction-right"></i>
              </div>
            </div>
          </a>
        </>
      );
    } else {
      return null;
    }
  }
}
